'use client';

import isPrintModalEnabled from '../utils/isPrintModalEnabled';
import useExperiments from './useExperiments';

const useIsPrintModalEnabled = (): boolean => isPrintModalEnabled(useExperiments());

export default useIsPrintModalEnabled;
